module.exports = __webpack_public_path__ + "static/media/WIGME-kuwait.fc8de639.png";